import { map, pipe } from "rxjs"
import { Lead } from "src/app/core/models/lead/lead.model"
import { LeadDto } from "src/app/infrastructure/lobby-proxy/DTOs/lead.dto"
import { comuneDtoToMunicipality } from "../common-model-dto/municipality-dto.mapping"
import { provinceDtoToProvince } from "../common-model-dto/province-dto.mapping"
import { leadAssignationDtoToLeadAssignation } from "./lead-assingation-dto.mapping"
import { leadAssignationOfferDtoToLeadAssignationOffer } from "./lead-offer-dto.mapping"
import { leadRawValueDtoToLeadRawValue } from "./lead-raw-value-dto.mapping"
import { statusHistoryEntryArrDtoToLeadStatusTransitionArr } from "./lead-status-transition-dto.mapping"
import { leadSummaryDtoToLeadSummary } from "./lead-summary-dto.mapping"

export const mapLeadDtoToLead = pipe(
    map((source: LeadDto) => leadDtoToLead(source))
)

export function leadDtoToLead(source: LeadDto): Lead {
    return {
        ...leadSummaryDtoToLeadSummary(source),
        municipality: comuneDtoToMunicipality(source.comune),
        province: provinceDtoToProvince(source.provincia ?? source.comune?.provincia),
        rawValues: source.rawValues?.map(r => leadRawValueDtoToLeadRawValue(r)) ?? [],
        assignationHistory: source.assignations?.map(a => leadAssignationDtoToLeadAssignation(a)) ?? [],
        offerHistory: source.assignationOffers?.map(o => leadAssignationOfferDtoToLeadAssignationOffer(o)) ?? [],
        statusHistory: statusHistoryEntryArrDtoToLeadStatusTransitionArr(source.statusHistory, source.created)
    } as Lead
}
